// extracted by mini-css-extract-plugin
export default {"root":"_2nf2E","heading-and-subheading-block":"_3Ulbd","headingAndSubheadingBlock":"_3Ulbd","subheading":"_1wo2V"};